module.exports = __webpack_public_path__ + "img/Bronze.ea2694b8.png";